const COLUMN_TAG_INVARIANTS = ['section', 'div', 'main', 'aside', 'nav', 'li', 'ul', 'ol'];

const invariants = {
    COLUMN_TAG_INVARIANTS,
};

export default invariants;

export { COLUMN_TAG_INVARIANTS };
